export default __webpack_public_path__ + "static/LP4-28c299ecb438b4e8c5aca1c6afef5c24.png";